import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, StatusBadge, Empty, DemoBadge } from "@/components/Badges";
import { KIND_LABELS, STATUS_LABELS, fmtDate, gbp } from "@/lib/format";

export default function Applications() {
  const { orgId } = useAuth();
  const [rows, setRows] = useState(null);
  const [status, setStatus] = useState("");
  const [kind, setKind] = useState("");
  useEffect(() => {
    if (orgId) api.get(`/orgs/${orgId}/applications`).then(({ data }) => setRows(data));
  }, [orgId]);
  const shown = (rows || []).filter((a) => (!status || a.status === status) && (!kind || (kind === "ip" ? a.kind !== "grant" : a.kind === kind)));
  return (
    <div className="fade-up">
      <PageHeader title="Applications" sub="IP filings are tracked separately from registration or grant. Funding shows requested, awarded and paid amounts separately.">
        <select aria-label="Type" data-testid="apps-kind-filter" className="input" value={kind} onChange={(e) => setKind(e.target.value)}><option value="">All types</option><option value="grant">Funding</option><option value="ip">IP</option></select>
        <select aria-label="Status" data-testid="apps-status-filter" className="input" value={status} onChange={(e) => setStatus(e.target.value)}><option value="">All statuses</option>{Object.entries(STATUS_LABELS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}</select>
      </PageHeader>
      {rows && !shown.length && <Empty title="No applications">Start one from a project or a funding opportunity.</Empty>}
      <div className="space-y-3">
        {shown.map((a) => (
          <Link key={a.id} to={`/app/applications/${a.id}`} data-testid={`application-row-${a.id}`} className="card flex flex-col gap-2 p-5 transition-colors hover:border-[#0D9488] sm:flex-row sm:items-center sm:justify-between">
            <div>
              <div className="flex flex-wrap items-center gap-2"><span className="caption">{KIND_LABELS[a.kind]}</span>{a.is_demo && <DemoBadge text="Demo" />}</div>
              <p className="mt-1 font-display font-semibold text-[#0B192C]">{a.title}</p>
              <p className="mt-1 text-xs text-slate-500">
                {a.kind === "grant" ? `Requested ${gbp(a.amounts?.requested)} · Awarded ${gbp(a.amounts?.awarded)} · Paid ${gbp(a.amounts?.paid)}` : ["copyright_record", "know_how"].includes(a.kind) ? "Internal record - not filed with any official body" : `Filed ${fmtDate(a.ip?.filing_date)} · Registered/granted ${fmtDate(a.ip?.registration_date)}`}
              </p>
            </div>
            <StatusBadge status={a.status} kind={a.kind} />
          </Link>
        ))}
      </div>
    </div>
  );
}
